<template>
    <div class="hello">
        <v-layout class="grid grid-one dark-bg" style="position: relative">
            <h1>(404) - Sidan hittades inte</h1>
            <br><h1 style="margin-top: 20px;font-size: 60px;">?</h1>
        </v-layout>
    </div>
</template>

<script>
    export default {};
</script>